import { render } from "@/components/pages/immobilizer/imbRegisterSteeringLockCUType3/IMBRegisterSteeringLockCUType3.html?vue&type=template&id=0cafbf3e&external"
import script from "@/components/pages/immobilizer/imbRegisterSteeringLockCUType3/IMBRegisterSteeringLockCUType3.js?vue&type=script&lang=js&external"
export * from "@/components/pages/immobilizer/imbRegisterSteeringLockCUType3/IMBRegisterSteeringLockCUType3.js?vue&type=script&lang=js&external"

import "@/components/pages/immobilizer/imbRegisterSteeringLockCUType3/IMBRegisterSteeringLockCUType3.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__